/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DurationLikeObject } from './DurationLikeObject';
import {
    DurationLikeObjectFromJSON,
    DurationLikeObjectFromJSONTyped,
    DurationLikeObjectToJSON,
} from './DurationLikeObject';

/**
 * 
 * @export
 * @interface InvalidCountRule
 */
export interface InvalidCountRule {
    /**
     * Length of the rolling window counted backward from now.
     * @type {DurationLikeObject}
     * @memberof InvalidCountRule
     */
    windowDuration: DurationLikeObject;
    /**
     * Event count that triggers the rule when the windowed count reaches this value.
     * @type {number}
     * @memberof InvalidCountRule
     */
    threshold: number;
    /**
     * 
     * @type {string}
     * @memberof InvalidCountRule
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidCountRule
     */
    id: string;
}

/**
 * Check if a given object implements the InvalidCountRule interface.
 */
export function instanceOfInvalidCountRule(value: object): value is InvalidCountRule {
    if (!('windowDuration' in value) || value['windowDuration'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InvalidCountRuleFromJSON(json: any): InvalidCountRule {
    return InvalidCountRuleFromJSONTyped(json, false);
}

export function InvalidCountRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvalidCountRule {
    if (json == null) {
        return json;
    }
    return {
        
        'windowDuration': DurationLikeObjectFromJSON(json['windowDuration']),
        'threshold': json['threshold'],
        'displayName': json['displayName'],
        'id': json['id'],
    };
}

export function InvalidCountRuleToJSON(value?: InvalidCountRule | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'windowDuration': DurationLikeObjectToJSON(value['windowDuration']),
        'threshold': value['threshold'],
        'displayName': value['displayName'],
        'id': value['id'],
    };
}

